import { NgClass } from '@angular/common';
import { Component, OnInit, ViewEncapsulation, inject, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BusinessSubject } from './../../../../_common/model/business-subject';
import { User } from './../../../../_common/model/user';
import { BaseState } from './../../../../_common/state/base/base.state';

@Component({
    selector: 'lay-men-header',
    templateUrl: './lay-men-header.component.html',
    styleUrls: ['./lay-men-header.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgClass, RouterLink, NgbTooltip],
})
export class LayMenHeaderComponent implements OnInit {
    private store = inject(Store);

    // @TODO: Ignored with eslint-interactive on 2023-09-15
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    readonly onMenuSizeChange = output<boolean>();

    public bs?: BusinessSubject = this.store.selectSnapshot(BaseState.getBS);
    public user?: User = this.store.selectSnapshot(BaseState.getUser);
    public isMin = false;
    private onDestroy$ = new Subject<void>();

    ngOnInit() {
        this.store
            .select(BaseState.getBS)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(bs => (this.bs = bs));
    }

    public minMenu(): void {
        this.isMin = !this.isMin;
        this.onMenuSizeChange.emit(this.isMin);
    }
    // @TODO: Ignored with eslint-interactive on 2023-09-15
    // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
    ngOnDestroy(): void {
        this.onDestroy$.next();
    }
}
